import { inputFocused } from '../components/inputFocused';
import { TrackingCategory } from '../enums';
import type { TrackingContextValue } from '../providers/TrackingContext';

export const searchFocused = (tracking: TrackingContextValue, fieldName: string) =>
  inputFocused(
    { ...tracking, category: TrackingCategory.Casino },
    { fieldName, fieldType: 'text' }
  );
